import { render, staticRenderFns } from "./SeriesPage.vue?vue&type=template&id=fb842c9c&"
import script from "./SeriesPage.vue?vue&type=script&lang=js&"
export * from "./SeriesPage.vue?vue&type=script&lang=js&"
import style0 from "./SeriesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports